import isNil from "lodash/isNil";
export const getStateHandlers = (selection) => {
    const newSelection = isNil(selection) ? [] : Array.isArray(selection) ? [...selection] : [selection];
    const getNewSelection = (key) => {
        const index = newSelection.indexOf(key);
        if (index === -1) {
            // Add to selection
            newSelection.push(key);
        }
        else {
            // Remove from selection
            newSelection.splice(index, 1);
        }
        return newSelection;
    };
    const isSelected = (key) => Boolean(key !== null && Array.isArray(selection) ? selection.includes(key) : selection === key);
    return { getNewSelection, isSelected };
};
